"use client";
import Link from "next/link";
import { Button } from "@taskflow/ui";
import { Home } from "lucide-react";
export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <h1 className="text-7xl font-bold text-slate-900">404</h1>
        <p className="mt-3 text-lg font-medium text-slate-700">页面不存在</p>
        <p className="mt-2 text-sm text-slate-500">你访问的页面可能已被移除, 或地址错误。</p>
        <Link href="/workspace/dashboard" className="mt-6 inline-block">
          <Button iconLeft={<Home className="h-4 w-4" />}>返回工作台</Button>
        </Link>
      </div>
    </div>
  );
}
